import { CollectStatus } from '@/webgl/runner/entities/CollectibleEntity'
import { SequenceAlternativeMode, SequenceConfig, SequenceView } from '@/webgl/runner/scenarios/SequenceConfig.types'

export type CompletionBlock = {
  status: CollectStatus
  goal: string[]
  collected: string[]
  failed: string[]
  goalText?: string
  goalTextDM?: boolean
}

export type SequenceCompletion = {
  view: SequenceView
  currentBlock: number
  blocks: CompletionBlock[]
  alternativeMode?: SequenceAlternativeMode
}

export function splitCompletionBlock(block: CompletionBlock): CompletionBlock[] {
  const blocks: CompletionBlock[] = []
  const blen = block.goal.length
  const split = Math.floor(blen / 2)

  for (let i = 0; i < 2; i++) {
    const goal = block.goal.slice(i * split, (i + 1) * split)
    const collected = block.collected.filter((c) => goal.includes(c))
    const failed = block.failed.filter((c) => goal.includes(c))
    const goalText = block.goalText && i == 0 ? block.goalText : undefined
    const goalTextDM = block.goalTextDM && i == 0 ? block.goalTextDM : undefined

    let status = collected.length == goal.length ? CollectStatus.Succeed : CollectStatus.Neutral
    if (failed.length > 0) {
      status = CollectStatus.Failed
    }

    blocks.push({
      status,
      goal,
      collected,
      failed,
      goalText,
      goalTextDM,
    })
  }

  return blocks
}

export function createSequenceCompletion(config: SequenceConfig): SequenceCompletion {
  const blocks: CompletionBlock[] = []

  for (let i = 0; i < config.goals.length; i++) {
    const goal = [...config.goals[i]]
    const collected = config.collected && i < config.collected.length ? [...config.collected[i]] : []
    const goalText = config.goalText && i == 0 ? config.goalText : undefined
    const goalTextDM = config.goalTextDM && i == 0 ? config.goalTextDM : undefined

    blocks.push({
      status: CollectStatus.Neutral,
      goal,
      collected,
      failed: [],
      goalText,
      goalTextDM,
    })
  }

  return {
    view: config.view,
    alternativeMode: config.alternativeMode,
    blocks: blocks,
    currentBlock: 0,
  }
}
